import * as types from '../mutation-types'
import { apiV2 } from '../api'
import Vue from 'vue'

const _isFalsy = (val) => _.isNil(val) || _.isEmpty(val) || val == 0 || val === false
const _isValid = (val) => !_isFalsy(val)

const requestCancel = {
  token: Vue.axios.CancelToken,
  source: null
}

const validationRequestsV2 = {
  namespaced: true,

  state: {
    validationRequests: {},
    filters: {
      status: 'pending',
    },
    sort: 'created_at',
    validationRequest: null,
    requestCancel
  },

  mutations: {
    [types.VALIDATION_REQUESTS_FETCHED] (state, payload) {
      state.validationRequests = payload
    },

    [types.REQUEST_TOKEN_SOURCE_CHANGED](state, source) {
      state.requestCancel.source = source
    },

    [types.VALIDATION_REQUESTS_FILTERS_UPDATED] (state, payload) {
      state.filters = payload
      state.validationRequests = []
    },
    
    [types.VALIDATION_REQUESTS_SORT_UPDATED] (state, payload) {
      state.sort = payload
      state.validationRequests = []
    },

    [types.VALIDATION_REQUEST_FETCHED] (state, payload) {
      state.validationRequest = payload.data
    }
  },

  actions:{
    getValidationRequests({commit, state, getters}, params) {
      if (!_.isNull(state.requestCancel.source)) {
        state.requestCancel.source.cancel()
      }

      const token = state.requestCancel.token,
        source = token.source(),
        cancelToken = source.token
      
      commit(types.REQUEST_TOKEN_SOURCE_CHANGED, source)

      const queryParams = {
        ...params,
        filter: {
          ...(params.filter || {}),         // Utilise la propriété existante `filter` ou un objet vide si elle n'existe pas
          agency: state.filters.agency_id,
          status: state.filters.status,
          group: state.filters.group,
        },
        sort: state.sort
      }

      if (!queryParams.hasOwnProperty('page')) {
        queryParams.page = 1
      }

      return apiV2.getValidationRequests(queryParams, cancelToken)
        .then((response) => commit (types.VALIDATION_REQUESTS_FETCHED, response.data))
    },

    updateFilter({commit, dispatch}, filters) {
      commit(types.VALIDATION_REQUESTS_FILTERS_UPDATED, filters)
    },

    updateSort({commit, dispatch}, sort) {
      commit(types.VALIDATION_REQUESTS_SORT_UPDATED, sort)
    },

    getValidationRequest({commit}, validationRequestId) {
      const params = {
        with: 'type,customer.main_representative,validation_requestable,child_requests,creating_user,treating_user,customer_documents'
      }
  
      return apiV2.getValidationRequest(validationRequestId, params)
        .then((response) => commit (types.VALIDATION_REQUEST_FETCHED, response.data))
    }
  }
}

export default validationRequestsV2



// WEBPACK FOOTER //
// ./client/store/modules/validationRequestsV2.js